import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateTiktokIntegrationMutation = createMutationHook(
  ShopRendererApiClient.createTiktokIntegration,
  {
    mutationKey: ['createTiktokIntegration'],
  },
)
